export const magazziniLogiciConst = {
  STOCK: "01",
  GARANZIA: "02",
  CVENDITA: "CV_IN",
  CVENDITAOUT: "CV_OUT",
};

export const codiciTipoMagazzino = {
  MONTATURE: 0,
  LENTIOFTALMICHE: 1,
  LAC: 2,
  LIQUIDIACCESSORI: 3,
  SERVIZI: 4,
};
